import { createApi } from '@reduxjs/toolkit/query/react';
import  baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';

export const ushersApi = createApi({
	reducerPath: 'ushersApi',
	tagTypes: ['ushers'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getAllUsher: builder.query({
			query: () => ({
				url: `ushers/all`,
			}),
			providesTags: ['ushers'],
		}),
		getUsherProfile: builder.query({
			query: () => ({
				url: `ushers/profile`,
			}),
			providesTags: ['ushers'],
		}),
		getUshers: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `ushers`,
				params: { page, ...handleGlobalSearch(filters, ['email']) },
			}),
			providesTags: ['ushers'],
		}),
		deleteUshers: builder.mutation({
			query: (id: UUID) => ({
				url: `ushers/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['ushers'],
		}),
		addUsher: builder.mutation({
			query: ({ email, password, name }: { name: string; email: string; password: string }) => ({
				url: `ushers`,
				method: 'POST',
				body: { name, email, password },
			}),
			invalidatesTags: ['ushers'],
		}),
		updateUsher: builder.mutation({
			query: ({ name, email, password, id }: { name: string; email: string; password: string; id: UUID }) => ({
				url: `ushers/${id}`,
				method: 'PATCH',
				body: { name, email, password },
			}),
			invalidatesTags: ['ushers'],
		}),
		resetUsherPassword: builder.mutation({
			query: ({ password, id }: { password: string; id: UUID }) => ({
				url: `ushers/${id}/reset-password`,
				method: 'PATCH',
				body: { password },
			}),
			invalidatesTags: ['ushers'],
		}),
		changePassword: builder.mutation({
			query: ({ oldPassword, newPassword }: { oldPassword: string; newPassword: string }) => ({
				url: `ushers/change-password`,
				method: 'PATCH',
				body: { oldPassword, newPassword },
			}),
			invalidatesTags: ['ushers'],
		}),
	}),
});

export const {
	useGetAllUsherQuery,
	useAddUsherMutation,
	useUpdateUsherMutation,
	useDeleteUshersMutation,
	useGetUshersQuery,
	useResetUsherPasswordMutation,
	useChangePasswordMutation,
	useGetUsherProfileQuery
} = ushersApi;
